import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import ScrollToTop from '@/components/base/ScrollToTop';
import { articles, categories } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="pt-24 min-h-[60vh] flex flex-col items-center justify-center px-4">
          <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-4">
            分类未找到
          </h1>
          <Link
            to="/"
            className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            返回首页
          </Link>
        </div>
        <Footer />
      </>
    );
  }

  const categoryArticles = articles.filter((a) => a.category === slug);

  const colorClasses = category.color === 'primary'
    ? 'bg-primary-100 text-primary-700'
    : category.color === 'accent'
      ? 'bg-accent-100 text-accent-700'
      : 'bg-secondary-100 text-secondary-700';

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <div className="pt-16">
        <Breadcrumb />
      </div>
      <main>
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <div className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-4 ${colorClasses} text-sm font-medium`}>
                <i className={`${category.icon} text-base`}></i>
                <span>{category.name}</span>
              </div>
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
                {category.name}
              </h1>
              <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
                {category.description}
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-2 mb-10">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200/70'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {categoryArticles.map((article) => (
                  <ArticleCard
                    key={article.id}
                    id={article.id}
                    slug={article.slug}
                    title={article.title}
                    excerpt={article.excerpt}
                    image={article.image}
                    date={article.date}
                    readTime={article.readTime}
                    category={article.category}
                    categoryName={category.name}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                  <i className="ri-inbox-line text-2xl"></i>
                </div>
                <p className="text-foreground-500">暂无相关文章</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}